import { render } from "./SidenavMenu.vue?vue&type=template&id=40942aa0"
import script from "./SidenavMenu.vue?vue&type=script&lang=js"
export * from "./SidenavMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__